import { Box, TextField, Typography } from '@mui/material'

export const TextFieldBlock = ({
  title,
  placeholder,
  isMultiline = false,
  maxLength = 60,
  minRows = 0,
  fullWidth = false,
  value,
  onChange,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    gap={2}
    width={fullWidth ? '100%' : 'auto'}
  >
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography
        variant="h6"
        color={'text.secondary'}
        padding={'12px 0'}
      >
        {title}
      </Typography>
    </Box>

    <TextField
      value={value}
      minRows={minRows}
      multiline={isMultiline}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      inputProps={{ maxLength }}
      sx={(theme) => ({
        height: isMultiline ? 'auto' : 40,
        '& textarea::placeholder': {
          color: theme.palette.text.tertiary,
          ...theme.typography.body2,
        },
      })}
    />
  </Box>
)
